export const initialise = () => {
    document.addEventListener('DOMContentLoaded', () => {
        playButtonListener();
    });
}


const setAutoplayUrl = (url: string): string => {
    // Handle YouTube URLs - convert to embed format with autoplay
    if (url.includes('youtube') || url.includes('youtu.be')) {
        // Extract video ID from various YouTube URL formats (including Shorts)
        const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11,})/);
        const videoId = videoIdMatch ? videoIdMatch[1] : null;
        
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}?autoplay=1&origin=https://youtube.com`;
        }
    }
    
    // Handle Vimeo URLs - convert to player embed format with autoplay
    if (url.includes('vimeo')) {
        const videoIdMatch = url.match(/vimeo\.com\/(?:.*\/)?(\d+)(?:[?#].*)?$/);
        const videoId = videoIdMatch ? videoIdMatch[1] : null;
        
        if (videoId) {
            return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }
    }
    
    // For other URLs, append autoplay parameter
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}autoplay=1`;
};

const playButtonListener = () => {
    const playButtons = document.querySelectorAll('.cust-recruiter-video__play');

    playButtons.forEach(button => {
        button.addEventListener('click', () => {
            const parent = button.closest('.banner-customhtml');
            const iframe = parent?.querySelector('iframe') as HTMLIFrameElement;
            if (iframe) {
                const src = iframe.src;


                if (src.indexOf('autoplay=1') === -1) {
                    iframe.src = setAutoplayUrl(src);
                    parent?.classList.add('video-playing');
                }
            }  
        });
    });
};